export const getKeywordIcon = (event?: string) => {
  if (typeof event !== "string") {
    return;
  }

  let url = "";
  switch (event) {
    case "로켓배송":
      url = require("assets/images/store/ic_store_rocket.png");
      break;
    case "무료배송":
      url = require("assets/images/store/ic_store_truck.png");
      break;
    case "일반배송":
      url = require("assets/images/store/ic_store_box.png");
      break;
    case "이벤트":
      url = require("assets/images/store/ic_quick_benefit_solid.png");
      break;
    default:
      return;
  }

  return url;
};
